import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateExpenseCategoryService, type UpdateExpenseCategoryPayload } from '@/services/expenseCategories'
import { expenseCategoriesQueryKey } from './useExpenseCategories'

export const useUpdateExpenseCategory = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ categoryId, payload }: { categoryId: number; payload: UpdateExpenseCategoryPayload }) =>
      updateExpenseCategoryService(agendaId, categoryId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: expenseCategoriesQueryKey(agendaId) })
    },
  })
}
